import React, { Component } from 'react';
import pickBy from 'lodash/pickBy';
import { reduxForm, Field } from 'redux-form';
import TextField from 'common/components/form/TextField';
import querystring from 'query-string';
import fileDownload from 'js-file-download';

import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';

import { CURRENT_ACADEMIC_YEAR } from 'common/constants/years';
import AcademicInput from 'common/components/form/AcademicInput';
import Toolbar from 'common/components/ToolBar';
import { FormCard, FormCardSection, FormCardContent } from 'common/components/FormCard';
import LoadingFileDialog from 'common/components/download/LoadingFileDialog';
import { isAcademicYear } from 'common/helpers/validation';
import axios from 'public/helpers/MyAxios';
import CoordDepartmentDropdown from './CoordDepartmentDropdown';

const buildQuery = (search, sendEmpty = false) => {
  // remove empty array
  let data = pickBy(
    search,
    // filter empty array as querystring have strange behaviour
    value => (Array.isArray(value) ? Boolean(value.length) : true),
  );
  if (!sendEmpty) {
    // remove empty input to shorten the params
    data = pickBy(
      data,
      // filter empty array as querystring have strange behaviour
      value => Boolean(value),
    );
  }
  return querystring.stringify(data, { arrayFormat: 'bracket' });
};


const validate = (values) => {
  const errors = {};
  errors.year = isAcademicYear(values?.year);
  if (!values.department_codes) {
    errors.department_codes = 'Required';
  }
  return errors;
};
const styles = theme => ({
  field: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

class ResponseRateForm extends Component {

  constructor(props) {
    super(props);
    this.doSubmit = this.doSubmit.bind(this);
  }

  state = {
    progess: null,
    loading: false,
    notiMessage: null,
  };

  async doSubmit(values) {
    this.downloadFile(`/coordinator/report/response-rate?${buildQuery(values)}`, `Response Rate_${values?.department_codes?.[0] || ''}.xlsx`);
  }

  downloadFile(path, filename) {
    this.setState(
      { loading: true, notiMessage: null },
      async () => {
        try {
          const response = await axios.get(axios.addApiUrl(path), {
            responseType: 'blob',
            onDownloadProgress: e => this.setState({ progess: { loaded: e.loaded, total: e.total } }),
          });
          fileDownload(response.data, filename);
          this.setState({ loading: false, progess: null });
        } catch (e) {
          this.setState({ loading: false, progess: null, notiMessage: `Error: ${e.message}` });
        }
      },
    );
  }


  render() {
    const { handleSubmit, classes } = this.props;
    const { notiMessage, loading, progess } = this.state;
    return (
      <div>
        <Toolbar
          title="Response Rate Report"
          color="default"
        />
        <LoadingFileDialog open={loading} progress={progess} />
        <form onSubmit={handleSubmit(this.doSubmit)}>
          <FormCard>
            <CardContent>
              <FormCardSection>
                <div className={classes.field}>
                  <InputLabel>Departments</InputLabel>
                  <Field
                    name="department_codes"
                    component={CoordDepartmentDropdown}
                    placeholder=" "
                    allowEmpty
                    parse={c => (c && c.length > 0 ? [c] : [])}
                    format={c => (Array.isArray(c) && c.length > 0 ? c[0] : '')}
                    fullWidth
                  />
                </div>
                <Field
                  className={classes.field}
                  label="Academic Year"
                  name="year"
                  component={TextField}
                  fullWidth
                  InputProps={{
                    inputComponent: AcademicInput,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Field
                  className={classes.field}
                  label="Course Type"
                  name="type"
                  component={TextField}
                  select
                  SelectProps={{ native: true }}
                  fullWidth
                >
                  <option value="" />
                  <option value="UG">UG</option>
                  <option value="PG">PG</option>
                </Field>
              </FormCardSection>
            </CardContent>
            <CardActions>
              <FormCardContent>
                <Button type="submit" variant="contained" color="primary">Download Report</Button>
                {notiMessage ? <Typography color="error">{notiMessage}</Typography> : null}
              </FormCardContent>
            </CardActions>
          </FormCard>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'ResponseRateForm',
  validate,
  initialValues: {
    year: CURRENT_ACADEMIC_YEAR,
  },
})(withStyles(styles)(ResponseRateForm));
